import * as yup from "yup";

export const VideoGalleryValidation = yup.object().shape({
    folder_id: yup.string().required("Folder is required"),
    video_thumbnail: yup.string().required("Required"),
    url: yup.string().required("Required"),
});
